import { PageFormat } from "@redotech/redo-model/outbound-labels";
import * as z from "zod/v4";

export const printTest = {
  name: "printTest" as const,
  input: z.object({
    printerId: z.number(),
    pageFormat: z.enum(PageFormat),
    paper: z.string().optional(),
    rotate: z.union([
      z.literal(0),
      z.literal(90),
      z.literal(180),
      z.literal(270),
    ]),
    fit_to_page: z.boolean().optional(),
    dpi: z.string().optional(),
    bin: z.string().optional(),
    duplex: z
      .union([
        z.literal("long-edge"),
        z.literal("short-edge"),
        z.literal("one-sided"),
      ])
      .optional(),
  }),
  output: z.object({}),
};

export type PrintTestInput = z.infer<typeof printTest.input>;
